import { QueryConfiguration } from '@nucleus/lib-dynamodb';
import { Stage } from './stage';
import { getTableName } from './utilities/tables';

export const MessagesTableName = getTableName('messages', 'NucleusPlatformResources', Stage);

export const MessagesTableKeys = {
  partkey: 'partkey',
  sortkey: 'sortkey',
  gsi1name: 'gsi1',
  gsi1partkey: 'gsi1_partkey',
  gsi1sortkey: 'gsi1_sortkey',
  gsi2name: 'gsi2',
  gsi2partkey: 'gsi2_partkey',
  gsi2sortkey: 'gsi2_sortkey',
  gsi3name: 'gsi3',
  gsi3partkey: 'gsi3_partkey',
  gsi3sortkey: 'gsi3_sortkey',
  ttl: 'delete_after',
} as const;

export type MessagesTablePrimaryKeys = {
  [MessagesTableKeys.partkey]: string;
  [MessagesTableKeys.sortkey]: string;
};

export type MessagesTableGsi1Keys = {
  [MessagesTableKeys.gsi1partkey]: string;
  [MessagesTableKeys.gsi1sortkey]: string;
};

export type MessagesTableGsi2Keys = {
  [MessagesTableKeys.gsi2partkey]: string;
  [MessagesTableKeys.gsi2sortkey]: string;
};

export type MessagesTableGsi3Keys = {
  [MessagesTableKeys.gsi3partkey]: string;
  [MessagesTableKeys.gsi3sortkey]: string;
};

export type MessagesTableTtlKeys = {
  [MessagesTableKeys.ttl]: number;
};

export const MessagesTablePrimaryQueryConfig: QueryConfiguration = {
  partKey: MessagesTableKeys.partkey,
  sortKey: MessagesTableKeys.sortkey,
};

export const MessagesTableGsi1QueryConfig: QueryConfiguration = {
  name: MessagesTableKeys.gsi1name,
  partKey: MessagesTableKeys.gsi1partkey,
  sortKey: MessagesTableKeys.gsi1sortkey,
};

export const MessagesTableGsi2QueryConfig: QueryConfiguration = {
  name: MessagesTableKeys.gsi2name,
  partKey: MessagesTableKeys.gsi2partkey,
  sortKey: MessagesTableKeys.gsi2sortkey,
};

export const MessagesTableGsi3QueryConfig: QueryConfiguration = {
  name: MessagesTableKeys.gsi3name,
  partKey: MessagesTableKeys.gsi3partkey,
  sortKey: MessagesTableKeys.gsi3sortkey,
};
